import { useMemo } from 'react'
import { useEnumTranslation, TranslationHandler } from '../useEnumTranslation'
import { FocusReason as TranslationKey } from '../../'
import { makeTranslationProxy } from '../util'

const useFocusReasonTranslations = () => {
  const t = useEnumTranslation()

  return useMemo<Record<TranslationKey, TranslationHandler>>(() => {
    const translations: Record<TranslationKey, TranslationHandler> = {
      LOW_WEARING_TIME: (options) => t('focus_reasons.low_wearing_time', options),
      NO_FOLLOW_UP_SCHEDULED: (options) => t('focus_reasons.first_follow_up_not_scheduled', options),
      OUTCOME_FORM_MISSING: (options) => t('focus_reasons.outcome_form_missing', options),
      PDR_NOT_SIGNED: (options) => t('focus_reasons.pdr_not_signed', options),
      RETURN_INTENDED: (options) => t('focus_reasons.return_intended', options),
      UNREAD_MESSAGE: (options) => t('focus_reasons.unread_message', options),
    }

    return makeTranslationProxy(translations)
  }, [t])
}

export { useFocusReasonTranslations }
